<template>
  <div id="our-jobs">
    <ul class="post-list">
      <li class="post-item" v-for="item of this.$store.state.list" :key="item.id">
        <h3 class="post-name">{{ item.postName }}</h3>
        <h4 class="post-duty">{{ item.postDuty.name }}：</h4>
        <p
          class="duty-item"
          v-for="(i, index) of item.postDuty.duty"
          :key="index * 100"
        >
          {{ i }}
        </p>
        <h4 class="duty-request">{{ item.dutyRequest.name }}：</h4>
        <p
          class="request-item"
          v-for="(j, index) of item.dutyRequest.request"
          :key="index + 10"
        >
          {{ j }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "OurJobs",
  components: {},
  data() {
    return {
      list: [],
      list1: [
        {
          id: "1",
          postName: "总经理助理",
          postDuty: {
            name: "岗位职责",
            duty: [
              "1、协助并陪同总经理处理与美国保险公司、医疗机构、药房等合作，单位的业务交流、谈判、维护;",
              "2、协助总经理建设并管理好客户服务团队和业务团队; ",
              "3、协助总经理做好与美国、中国各分公司业务部门的沟通互动、业务协同，以及总经理安排的其他工作。"
            ]
          },
          dutyRequest: {
            name: "岗位要求",
            request: [
              "1、美国本科及以上学历;从事医健或健康保险相关领域，3年以上相关行政或业务管理经验;精通英文(口语必须好)和办公室软件；",
              "2、认同春华健康的服务理念,拥有符合岗位要求的学习与工作经历,愿意接受长期且持续的继续教育,有较强的服务意识、沟通能力和执行力,较好的英语沟通阅读能力。"
            ]
          }
        },
        {
          id: "2",
          postName: "全科医生",
          postDuty: {
            name: "岗位职责",
            duty: [
              "1、探索“互联网+家庭医学”在全科医学领域的运用；",
              "2、制定并实践全科诊疗规范与服务流程; ",
              "3、实施线上线下相结合的全科诊疗；",
              "4、参与集预防、疾病诊治、慢病管理、康复为一体的全流程服务；",
              "5、主导会员的健康管理、健康教育与效果评价。"
            ]
          },
          dutyRequest: {
            name: "岗位要求",
            request: [
              "1、临床医学专业本科及以上学历;",
              "2、主治医师及以上职称或规范化住院医生培训后3年,持有效执业医师资格证书；",
              "3、二级医院全科、急诊或内科工作3年以上,或一二线城市主要社区卫生服务中心工作3年以上；",
              "4、认同春华健康的服务理念,拥有符合岗位要求的学习与工作经历,愿意接受长期且持续的继续教育,有较强的服务意识、沟通能力和执行力,较好的英语沟通阅读能力。"
            ]
          }
        },
        {
          id: "3",
          postName: "心理医生",
          postDuty: {
            name: "岗位职责",
            duty: [
              "1、熟练掌握心理咨询、心理治疗相关方面的专业知识,提供系统的专业培训；",
              "2、通过电话或者网络等为客户提供心理咨询、测试、团体心理辅导,制定心理治疗计划,并指导实施; ",
              "3、对客户的心理成长、人格发展、智力、社会化及家庭、婚姻生活事件等进行全面评估,概括心理和生理测查。"
            ]
          },
          dutyRequest: {
            name: "岗位要求",
            request: [
              "1、教育学或应用心理学本科以上学历;",
              "2、心理咨询工作经验2年以上；",
              "3、具备很强的沟通力和学习力;较强的分析判断、组织协调和解决复杂问题的能力；",
              "4、需持有国家心理咨询师,医疗室,催眠师,AC国际注册心理咨询师等资质。"
            ]
          }
        },
        {
          id: "4",
          postName: "自媒体运营",
          postDuty: {
            name: "岗位职责",
            duty: [
              "1、负责微博、微信等自媒体的运营、推广,根据公司阶段性发展计划策划并执行线上营销活动;",
              "2、负责微博、微信等自媒体的内容发布、粉丝互动话题制造、活动执行; ",
              "3、了解CRM,根据粉丝会员相关数据策划互动率较高的营销活动及软文;",
              "4、根据事实热点撰写软文同时发布信息;",
              "5、建立有效运营手段提升网友活跃度,增加粉丝数,提高关注度;",
              "6、跟踪微博、微信推广效果,分析数据并反馈,分享微博推广经验。"
            ]
          },
          dutyRequest: {
            name: "岗位要求",
            request: [
              "1、本科及以上学历,具有1年或以上微博、微信运营等相关工作经验,良好美工基础;",
              "2、扎实的文字功底,头脑灵活,熟悉微博、微信运营、口碑营销、PR炒作、论坛SNS营销、SEO,有成功微博、微信运营经验者优先;",
              "3、对微博、网媒、自媒体、手机终端等新媒体运作有一定了解,对热点事件、新闻动态等信息敏感、把握能力强，能及时组织话言在微博、微信做出响应。",
              "4、有良好的团队协作精神和创新能力；",
              "5、热爱微博、微信等其他网络媒体。"
            ]
          }
        }
      ],
      list2: [
        {
          id: "1",
          postName: "Assistant of the manager",
          postDuty: {
            name: "Responsibilities of the position: ",
            duty: [
              "1.\tAssist and accompany the manager to make corporation with American insurance companies, medical institutions, and pharmacies;" +
                " communicate, negotiate and maintain at the workplace",
              "2、协助总经理建设并管理好客户服务团队和业务团队; ",
              "3、协助总经理做好与美国、中国各分公司业务部门的沟通互动、业务协同，以及总经理安排的其他工作。"
            ]
          },
          dutyRequest: {
            name: "岗位要求",
            request: [
              "1、美国本科及以上学历;从事医健或健康保险相关领域，3年以上相关行政或业务管理经验;精通英文(口语必须好)和办公室软件；",
              "2、认同春华健康的服务理念,拥有符合岗位要求的学习与工作经历,愿意接受长期且持续的继续教育,有较强的服务意识、沟通能力和执行力,较好的英语沟通阅读能力。"
            ]
          }
        },
        {
          id: "2",
          postName: "全科医生",
          postDuty: {
            name: "岗位职责",
            duty: [
              "1、探索“互联网+家庭医学”在全科医学领域的运用；",
              "2、制定并实践全科诊疗规范与服务流程; ",
              "3、实施线上线下相结合的全科诊疗；",
              "4、参与集预防、疾病诊治、慢病管理、康复为一体的全流程服务；",
              "5、主导会员的健康管理、健康教育与效果评价。"
            ]
          },
          dutyRequest: {
            name: "岗位要求",
            request: [
              "1、临床医学专业本科及以上学历;",
              "2、主治医师及以上职称或规范化住院医生培训后3年,持有效执业医师资格证书；",
              "3、二级医院全科、急诊或内科工作3年以上,或一二线城市主要社区卫生服务中心工作3年以上；",
              "4、认同春华健康的服务理念,拥有符合岗位要求的学习与工作经历,愿意接受长期且持续的继续教育,有较强的服务意识、沟通能力和执行力,较好的英语沟通阅读能力。"
            ]
          }
        },
        {
          id: "3",
          postName: "心理医生",
          postDuty: {
            name: "岗位职责",
            duty: [
              "1、熟练掌握心理咨询、心理治疗相关方面的专业知识,提供系统的专业培训；",
              "2、通过电话或者网络等为客户提供心理咨询、测试、团体心理辅导,制定心理治疗计划,并指导实施; ",
              "3、对客户的心理成长、人格发展、智力、社会化及家庭、婚姻生活事件等进行全面评估,概括心理和生理测查。"
            ]
          },
          dutyRequest: {
            name: "岗位要求",
            request: [
              "1、教育学或应用心理学本科以上学历;",
              "2、心理咨询工作经验2年以上；",
              "3、具备很强的沟通力和学习力;较强的分析判断、组织协调和解决复杂问题的能力；",
              "4、需持有国家心理咨询师,医疗室,催眠师,AC国际注册心理咨询师等资质。"
            ]
          }
        },
        {
          id: "4",
          postName: "自媒体运营",
          postDuty: {
            name: "岗位职责",
            duty: [
              "1、负责微博、微信等自媒体的运营、推广,根据公司阶段性发展计划策划并执行线上营销活动;",
              "2、负责微博、微信等自媒体的内容发布、粉丝互动话题制造、活动执行; ",
              "3、了解CRM,根据粉丝会员相关数据策划互动率较高的营销活动及软文;",
              "4、根据事实热点撰写软文同时发布信息;",
              "5、建立有效运营手段提升网友活跃度,增加粉丝数,提高关注度;",
              "6、跟踪微博、微信推广效果,分析数据并反馈,分享微博推广经验。"
            ]
          },
          dutyRequest: {
            name: "岗位要求",
            request: [
              "1、本科及以上学历,具有1年或以上微博、微信运营等相关工作经验,良好美工基础;",
              "2、扎实的文字功底,头脑灵活,熟悉微博、微信运营、口碑营销、PR炒作、论坛SNS营销、SEO,有成功微博、微信运营经验者优先;",
              "3、对微博、网媒、自媒体、手机终端等新媒体运作有一定了解,对热点事件、新闻动态等信息敏感、把握能力强，能及时组织话言在微博、微信做出响应。",
              "4、有良好的团队协作精神和创新能力；",
              "5、热爱微博、微信等其他网络媒体。"
            ]
          }
        }
      ]
    };
  },
  watch: {
    setList() {
      if (this.$i18n.locale === "en-US") {
        console.log(this.$i18n.locale);
        this.list = this.list1;
      } else if (this.$i18n.locale === "zh-CN") {
        this.list = this.list2;
        console.log(this.$i18n.locale);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#our-jobs {
  width: $width;
  /*background: #2a2a2a;*/
  margin: 0 auto;
  overflow: hidden;
  .post-list {
    margin-top: 24px;
    margin-bottom: 30px;
    .post-name {
      margin-top: 56px;
      color: #363636;
      font-size: 20px;
      margin-bottom: 42px;
      font-weight: 500;
    }
    .post-duty {
      font-size: 16px;
      color: #363636;
      /*margin-bottom: 10px;*/
      font-weight: 500;
    }
    .duty-item {
      color: #aaaaaa;
      font-size: 14px;
      line-height: 27px;
    }
    .duty-request {
      font-size: 16px;
      color: #363636;
      margin-top: 10px;
      font-weight: 500;
    }
    .request-item {
      color: #aaaaaa;
      font-size: 14px;
      line-height: 27px;
    }
  }
}
</style>
